// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"f79714d6","526":"10903a43"}[chunkId] + ".chunk.js";
};